import { render, staticRenderFns } from "./GameResult.vue?vue&type=template&id=484a0d67&scoped=true"
import script from "./GameResult.vue?vue&type=script&lang=js"
export * from "./GameResult.vue?vue&type=script&lang=js"
import style0 from "./GameResult.vue?vue&type=style&index=0&id=484a0d67&prod&lang=scss&scoped=true"
import style1 from "./GameResult.vue?vue&type=style&index=1&id=484a0d67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a0d67",
  null
  
)

export default component.exports